import React from 'react'
import { Col, Row } from 'reactstrap'
import { useLanguage } from '../../contexts/LanguageContext'

const OurApproach = () => {
  const { t } = useLanguage();
  return (
    <div id='website-responsive'>
        <div className='bg-img left-padding10rem1 right-padding10rem1 py-md-5 py-4' style={{ backgroundImage:'url("home/Our-approach-bg.webp")', width:'100%'}}>
            <div className='pb-md-5 pb-0' style={{ color:'#FE9B1F'}}>
                <center>
                    <h3 className='fs-ss-38 fw-800 text-philos text-ss-primary '>
                        {t('home.ourApproach.title')}
                    </h3>
                </center>
            </div>

            <div className=''>
                <Row className=''>

                <Col md='4' className='px-5  display-block-767'>
                        <div className='px-sm-5 py-4'>
                            <img src='home/Our-approach.webp' alt='' className='' width='100%'/>
                        </div>
                    </Col>

                    <Col md='4' className='mt-3 mt-md-0'>
                        <div className='' style={{ color:'#FE9B1F'}}>
                            <h3 className='fs-ss-30 fw-700 text-ss-primary text-philos' >
                                {t('home.ourApproach.envision.title')}
                            </h3>
                        </div>
                        <div className='fs-ss-16 text-mulish text-white fw-500 lh-1-2 '>
                        {t('home.ourApproach.envision.description')}
                        </div>
                        <div className='mt-3' style={{ borderTop:'2px solid white', width:'65%'}} />
                    </Col>

                    <Col md='4' className='display-none-767'>
                        <div className=''>
                            <img src='home/Our-approach.webp' alt='' className='' width='100%'/>
                        </div>
                    </Col>

                    <Col md='4' className='mt-3 mt-md-0'> 
                        <div className='' style={{ color:'#FE9B1F'}}>
                            <h3 className='fs-ss-30 fw-700 text-ss-primary text-philos' >
                                {t('home.ourApproach.execute.title')}
                            </h3>
                        </div>
                        <div className='fs-ss-16 text-mulish text-white fw-500 lh-1-2 '>
                        {t('home.ourApproach.execute.description')}
                        </div>
                        <div className='mt-3' style={{ borderTop:'2px solid white', width:'65%'}} /></Col>

                    <Col md='4' className=''></Col> 

                    <Col md='4' className='ms-lg-5 ms-md-4 pt-md-4 pt-4'> 
                        <div className='' style={{ color:'#FE9B1F'}}>
                            <h3 className='fs-ss-30 fw-700 text-ss-primary text-philos' style={{ color:'#FE9B1F'}}>
                                {t('home.ourApproach.enrich.title')}
                            </h3>
                        </div>
                        <div className='fs-ss-16 text-mulish text-white fw-500 lh-1-2 '>
                        {t('home.ourApproach.enrich.description')}
                        </div>
                        <div className='mt-3' style={{ borderTop:'2px solid white', width:'65%'}} /></Col>

                    <Col md='4' className=''></Col> 

                </Row>
            </div>
        </div>
    </div>
  )
}

export default OurApproach